<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <!-- ЧТО ИМЕННО ПРОИЗОЙДЁТ — СЛОВАМИ И ЗАМЕТНО. Списание последнее
                     в жизни вещи, и отменить его нечем; предупреждение здесь заменяет
                     второе окно подтверждения, которое всё равно прощёлкивают не читая. -->
                <p class="inventory-action-modal__warning">
                    Оборудование будет списано. Ответственный снимется, действия над ним станут недоступны — останется
                    только просмотр и история. Отменить списание нельзя.
                </p>

                <!-- ПРИЧИНА ОБЯЗАТЕЛЬНА. Именно к этой записи возвращаются
                     при инвентаризации и при разборе недостачи. -->
                <ValidationProvider
                    class="active-form__field"
                    name="write-off-comment"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="write-off-comment">
                        Причина списания
                    </label>

                    <VInput
                        id="write-off-comment"
                        name="write-off-comment"
                        class="active-form__control"
                        placeholder="Например: залит кофе, ремонт нецелесообразен"
                        :class="{ error: errors[0] }"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <!-- Красная кнопка, а не зелёная: цвет здесь единственное, что
                         отличает необратимое действие от обычного до нажатия. -->
                    <VButton
                        type="submit"
                        class="active-form__action inventory-action-modal__danger"
                        :disabled="isSaving"
                    >
                        {{ isSaving ? 'Списываем…' : 'Списать' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { writeOffInventoryItem } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Списание оборудования (7-F2B).
 *
 * ОДНО ОКНО, А НЕ ДВА. Второе подтверждение вида «вы уверены?» не добавляет решения:
 * его прощёлкивают не читая. Здесь роль подтверждения играет сама форма — обязательная
 * причина требует остановиться и подумать, а предупреждение и красная кнопка говорят,
 * что действие необратимо.
 *
 * УДАЛЕНИЯ НЕ ПРОИСХОДИТ: карточка и история остаются доступны на чтение.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemWriteOffModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_WRITE_OFF })
    name;
    @Prop({ type: String, default: 'Списание оборудования' })
    defaultTitle;

    itemId = null;
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await writeOffInventoryItem(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemWriteOffModal;
</script>
<style lang="scss">
.inventory-action-modal {
    // Предупреждение о необратимом действии: заметное, но не кричащее — красная
    // плашка во весь экран пугает и её перестают читать так же быстро, как второе окно.
    &__warning {
        margin: 0 0 16px;
        padding: 12px 14px;
        border-radius: 8px;
        background: #fdecea;
        color: #b3261e;
        font-size: 0.8125rem;
        line-height: 1.4;
    }

    // Красная кнопка действия. Своя, а не button_red: такого модификатора в проекте нет,
    // а заводить общий ради одного места значит договариваться о нём за всех.
    &__danger {
        border-color: #d93025;
        background: #d93025;
        color: #fff;

        &:hover:not(:disabled) {
            border-color: #b3261e;
            background: #b3261e;
        }
    }
}
</style>
